/**
 * Valid system types where components need to determine what environment they are being used in
 *
 * @readonly
 * @enum {SystemType}
 */
export const SystemType = {
    PASSPORT: 2,
    EHCP: 3,
    BOTH: 1,
}

export const systemTypeStringToInt = ( system_type_name ) =>
{
    switch ( system_type_name )
    {
        case 'PASSPORT':
            return SystemType.PASSPORT;
        case 'EHCP':
            return SystemType.EHCP;
        default:
            throw new Error(`Unknown system type ${system_type_name}`);
    }
}